import { FC } from 'react'

import { Button, PacoButtonLoadingSpinner } from '../../../../components'

import './MicrosoftLogin.scss'

export interface MicrosoftLoginProps {
    isLoading: boolean
    authenticationErrorMessage?: string
    onSubmit?: () => void
    className?: string
}

export const MicrosoftLogin: FC<MicrosoftLoginProps> = ({
    isLoading,
    authenticationErrorMessage,
    onSubmit,
    className,
}) => (
    <div className={`microsoft-login ${isLoading ? 'microsoft-login--loading' : ''} ${className}`}>
        <Button type="button" text="Inloggen met Microsoft" className="microsoft-login__button" onClick={onSubmit}>
            {isLoading && (
                <PacoButtonLoadingSpinner className="microsoft-login__button-loading-spinner" />
            )}
            {! isLoading && (
                <img
                    src="/images/microsoft-account-logo.svg"
                    alt=""
                    aria-hidden="true"
                    className="microsoft-login__button-logo"
                />
            )}
            <span className="microsoft-login__button-label">Inloggen met Microsoft</span>
        </Button>
        {authenticationErrorMessage && (
            <p className="microsoft-login__error-message">
                {authenticationErrorMessage}
            </p>
        )}
    </div>
)
